import { render } from "./Endereco.vue?vue&type=template&id=356f5886"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"

import "../css/transporte.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__